import {
  Inserter,
  Wrapper,
  SessionRole,
  PartMenu,
  DragAndDropContext,
  ExtensionView,
  useLocation,
} from "nystem-components";
import "./index.css";
import ErrorBoundary from "./errorBoundary.js";

const Index = () => {
  const { pathname } = useLocation();

  return (
    <ErrorBoundary>
      <ExtensionView type="background">
        <SessionRole userrole="logged-in">
          <Inserter source="/denon/extension/upstairs" />
        </SessionRole>
      </ExtensionView>
      <ExtensionView type="popup web">
        <DragAndDropContext>
          <SessionRole userrole="logged-out" className="remotor-pages">
            <PartMenu />
            <Inserter
              source="/adminUser/login"
              className="mt-12 max-w-xl px-2 pt-4 pb-4 text-gray-100 sm:pb-6"
              match="*"
            />
          </SessionRole>
          <SessionRole
            userrole="logged-in"
            className={[
              navigator.remotor && "remotor-iphone",
              pathname === "/" ||
              pathname === "/popup.html" ||
              pathname.startsWith("/event/front") ||
              pathname.startsWith("/event/fullfront")
                ? "text-base"
                : "remotor-pages text-base",
            ]}
          >
            <PartMenu />
            <Wrapper renderAs="main" className="mt-12 max-w-xl px-2 pt-3 pb-4 text-gray-100 empty:hidden sm:pb-6">
              <Inserter match="/" source="/event/frontAll" />
              <Inserter match="/popup.html" source="/event/frontAll" />
              <Inserter match="/remotorapp/*" source="/device/backlights" />
              <Inserter match="/denon/*" />
              <Inserter match="/energy/*" />
              <Inserter match="/energyRecording/*" />
              <Inserter match="/adminUser/*" />
              <Inserter match={["/event/front*", "/event/fullfront*"]} />
              <Inserter match="/touchscreen/*" />
              <Inserter
                match={[
                  "/device/input*",
                  "/device/view/*",
                  "/device/backlights*",
                  "/device/temperature/*",
                  "/device/brushing/*",
                  "/device/weight/*",
                  "/device/weighing/*",
                ]}
              />
              <Inserter match="/weighing/*" />
              <Inserter match="/device/settings" />
              <Inserter match="/velux/*" />
              <Inserter match="/homey/*" />
              <Inserter match="/homeyAutomation/*" />
              <Inserter match="/zigbee/*" />
              <Inserter match="/bluetooth/*" />
              <Inserter match="/roborock/*" />
              <Inserter match="/xiaomi/*" />
              <Inserter match="/hueLampStates/input*" />
              <Inserter match="/unit/input*" />
              <Inserter match="/remotorapp/*" />
              <Inserter match="/menuItem/*" />
              <Inserter match="/driveSync/*" />
              <Inserter match="/driveActivity/*" />
              <Inserter match="/computer/*" />
            </Wrapper>
            <Inserter
              match={[
                "/event/input*",
                "/event/list*",
                "/device/list*",
                "/device/overview*",
                "/schedule/*",
                "/unit/list*",
                "/hueLampStates/list*",
              ]}
              className="mt-12 px-2 pt-4 pb-4 text-gray-100 sm:pb-6"
            />
          </SessionRole>
        </DragAndDropContext>
      </ExtensionView>
    </ErrorBoundary>
  );
};

export default Index;
